'use client';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useGeneratedId } from '../../hooks/useGeneratedId.js';

/**
 * The generated id has colons and in querySelector these need to be escaped
 */
function escapeId(id) {
  return id.replace(/(:|\.|\[|\]|,|=|@)/g, '\\$1');
}
const Portal = ({
  children,
  id,
  root: initialRoot
}) => {
  const generatedId = useGeneratedId(id, 'portal');
  const [node, setNode] = useState(null);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!generatedId) return;
    const root = initialRoot || document.body;
    const portalDiv = document.createElement('div');
    portalDiv.id = generatedId;
    setNode(portalDiv);
    root.appendChild(portalDiv);
    return () => {
      /** Query the element to remove, in case it was modified externally.  */
      const portal = document.querySelector(`#${escapeId(generatedId)}`);
      if (portal) {
        root.removeChild(portal);
      }
    };
  }, [generatedId, initialRoot]);
  if (!node) return null;
  return ReactDOM.createPortal(children, node);
};

export { Portal };
//# sourceMappingURL=Portal.js.map
